import { escapeSpecialChars } from '../app/shared/util/utilities/escapeSpecialChars';

export function appendSimpleSearchFilter(filter: string, simpleSearchQuery: string, simpleSearchFields: string[]): string {
    if (simpleSearchQuery) {
        const encodedSearchText = encodeURIComponent(escapeSpecialChars(simpleSearchQuery.trim()));
        if (encodedSearchText) {
            if (filter.length > 0) {
                filter += '$and:';
            }

            let simpleSearchFilter = '';

            simpleSearchFields.forEach((field, idx) => {
                if (idx > 0) {
                    simpleSearchFilter += '$or:';
                }
                simpleSearchFilter += `${field}$like:${encodedSearchText}`;
            });

            filter = `${filter}(${simpleSearchFilter})`;
        }
    }

    return filter;
}
